import { defineMessages } from 'react-intl'

const messages = defineMessages({
  titleRoomDetails: {
    id: 'global.title-room-details',
  },
  bed: {
    id: 'room.bed',
  },
  beds: {
    id: 'room.beds',
  },
  discount: {
    id: 'discount.today',
  },
  selectedRoomsTitle: {
    id: 'detail.selected-rooms-title',
    // Same than in Rooms
  },
  oneRoomsLeft: {
    id: 'detail.selected-rooms-one',
  },
  roomsLeft: {
    id: 'detail.selected-rooms-left',
  },
  seeRoomDetails: {
    id: 'global.see-room',
  },
  total: {
    id: 'global.total',
  },
})

export default messages
